import qs from 'qs';
import get from 'lodash/get';
import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const BASE_URL = 'https://api.unsplash.com/';
const UTM_PARAMS = {
    utm_source: 'Splash',
    utm_medium: 'referral',
    utm_campaign: 'api-credit',
};
const PAGE_SIZE = 30;
const ORDER_BY = 'relevant';

function getApplicationId() {
    const bootstrap = getBootstrap();
    return bootstrap.get('unsplashApplicationId');
}

/**
 * Documentation: https://unsplash.com/documentation
 */
export default class UnsplashApiClient {
    constructor() {
        this.applicationId = getApplicationId();
    }

    _url(endpoint, params) {
        const queryString = qs.stringify(
            Object.assign(
                {
                    client_id: this.applicationId,
                },
                params,
            ),
        );
        return `${BASE_URL}${endpoint}?${queryString}`;
    }

    /**
     * Utility used to add the attribution parameters to links, requirement of the Unsplash API.
     * https://community.unsplash.com/developersblog/unsplash-api-guidelines
     * @param {string} href
     */
    addUtmParamsToHref(href) {
        const queryString = qs.stringify(UTM_PARAMS);
        return `${href}?${queryString}`;
    }

    /**
     * @param  {string} query
     * @param  {number|null} page
     * @return {Promise}
     */
    searchPhotos(query, page) {
        return axios
            .get(
                this._url('search/photos', {
                    query,
                    page: page || 1,
                    per_page: PAGE_SIZE,
                    order_by: ORDER_BY,
                }),
            )
            .then((response) => response.data);
    }

    /**
     *
     * @param {Object} unsplashImageDescriptor
     * @return {Promise}
     */
    submitUnsplashAssetDownloaded(unsplashImageDescriptor) {
        const url = get(unsplashImageDescriptor, 'links.download_location');

        const queryString = qs.stringify({
            client_id: this.applicationId,
        });

        const operator = url.includes('?') ? '&' : '?';
        return axios.get(`${url}${operator}${queryString}`);
    }
}
